import React from "react";
import { Redirect } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Heading from "../../waybee-ui/Heading";
import Group from "../../waybee-ui/Group";
import Button from "../../waybee-ui/Button";
import isClassDiaryDemo from "../../demo/isClassDiaryDemo";
import { resetDemoAndReload } from "../../demo/resetDemo";

function DemoSettings() {
  const { t } = useTranslation();

  if (!isClassDiaryDemo()) {
    return <Redirect to="/" />;
  }

  return (
    <Group>
      <Heading>{t("demo.title")}</Heading>
      <Box maxWidth={560} mt={1}>
        <Typography variant="body1" paragraph>
          {t("demo.body1")}
        </Typography>
        <Typography variant="body1" paragraph>
          {t("demo.body2")}
        </Typography>
        <Button
          color="primary"
          variant="contained"
          onClick={resetDemoAndReload}
        >
          {t("demo.reset")}
        </Button>
      </Box>
    </Group>
  );
}

export default DemoSettings;
